import { Directive, HostBinding } from '@angular/core';

@Directive({
  standalone: false,
  selector: '[campusToolbarNavigation], campus-toolbar-navigation',
})
export class ToolbarNavigationDirective {
  @HostBinding('class.shared-toolbar__navigation')
  hasToolbarNavigation = true;
  @HostBinding('attr.data-cy')
  dataCy = 'toolbar-nav';
}
